<template>
  <v-card flat>
    <v-card-title class="justify-center">
      <span class="text-h6 font-weight-light">
        Bản đồ phân bổ Cơ sở sản xuất, kinh doanh
      </span>
    </v-card-title>
    <v-card-text class="text-h5 font-weight-bold pa-0">
      <div class="map-container">
        <div class="map-frame">
          <div id="map"/>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
import L from 'leaflet';
import tggStates from '@/assets/states/tgg-states.json';
export default {
  name: "Example",
  data() {
    return {
      map: null,
      info: null
    };
  },
  mounted(){
    const app = this;
    app.map = L.map('map', {
      center: [ 10.420288, 106.296844 ],
      zoom: 10
    });
    app.map.scrollWheelZoom.disable();

    L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw', {
      maxZoom: 18,
      attribution: 'VNPT',
      id: 'mapbox/light-v9',
      tileSize: 512,
      zoomOffset: -1,
    }).addTo(app.map);

    var geojson = L.geoJson(tggStates, {
      style: app.style,
      onEachFeature: function(feature, layer){
        layer.on({
          mouseover: function (e) {
            var layer = e.target;
            layer.setStyle({
              weight: 5,
              color: '#666',
              dashArray: '',
              fillOpacity: 0.7
            });
            axios.get(`api/v1/get-count-by-district/${feature.properties.Code}`)
              .then(response => {
                var html_popup_content = "<div>Mã địa phương:" +
                  feature.properties.Code +
                  "</div><div>Tên địa phương: " +
                  feature.properties.Name +
                  "</div><div>Tổng cộng: " +
                  response.data +
                  " Cơ sở</div>";

                var myPopup = L.popup().setContent(html_popup_content);

                e.target
                  .unbindPopup()
                  .bindPopup(myPopup, {})
                  .openPopup();
              })
              .catch(function (error) {
                console.log(error);
              });
          },
          mouseout: function (e) {
            geojson.resetStyle(e.target);
          }
        })
      }
    }).addTo(this.map);

    var myRenderer = L.canvas({ padding: 0, width: 1, height: 1 });

    axios.get(`api/v1/businesses`)
      .then(response => {
        var cs = response.data.data;
        var LeafIcon = L.Icon.extend({
          options: {
            iconSize: [35, 35]
          }
        });  
        var plusIcon = new LeafIcon({iconUrl: require('@/assets/simple-marker.png')});
        for(let i = 0; i < cs.length; i++){
          if(cs[i].vi_tri !== null) {
            var lat_lg = cs[i].vi_tri.split(';')
            L.marker([lat_lg[0], lat_lg[1]], {
              icon: plusIcon,
              renderer: myRenderer,
              color: 'red'
            }).addTo(app.map);
          }
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }
};
</script>
<style>
  .map-container {
    position: relative;
    height: 500px;
    z-index: 0;
  }
  .map-frame {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;
  }
  #map {
    height: 100%;
  }
</style>